import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ExternalLink } from 'lucide-react';

export const GoogleMap = ({ className = '' }) => {
  // ISDE Academy Place ID
  const placeId = 'ChIJBYpjJIJjUjoRlLmeF5fWKWg';

  // Google Maps embed URL with Place ID
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBgOdoiEN5pPMo1MiB8JI-AzLXuESgAlZQ&q=place_id:${placeId}&zoom=15`;

  // Direct Google Maps link
  const directionsUrl = `https://www.google.com/maps/search/?api=1&query=place_id:${placeId}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={`space-y-4 ${className}`}
    >
      {/* Map Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <MapPin className="h-5 w-5 text-white" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Our Location</h3>
            <p className="text-sm text-gray-600">Chennai, Tamil Nadu, India</p>
          </div>
        </div>
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-sm transition-colors"
        >
          Get Directions
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>

      {/* Google Map Embed */}
      <div className="relative rounded-xl overflow-hidden shadow-2xl border-2 border-blue-100">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="relative w-full h-[400px] lg:h-[500px]"
        >
          <iframe
            src={mapUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ISDE Academy Location"
            className="w-full h-full"
          />
        </motion.div>

        {/* Overlay for enhanced visuals */}
        <div className="absolute inset-0 pointer-events-none border-2 border-blue-200/50 rounded-xl"></div>
      </div>

      {/* Additional Info */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 border border-blue-100"
      >
        <div className="grid md:grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-blue-600">📍</div>
            <div className="text-sm font-semibold text-gray-900 mt-2">Easy to Locate</div>
            <div className="text-xs text-gray-600 mt-1">Central Chennai Location</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-blue-600">🚗</div>
            <div className="text-sm font-semibold text-gray-900 mt-2">Accessible</div>
            <div className="text-xs text-gray-600 mt-1">Multiple Transport Options</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-blue-600">🅿️</div>
            <div className="text-sm font-semibold text-gray-900 mt-2">Parking Available</div>
            <div className="text-xs text-gray-600 mt-1">Convenient Parking Space</div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
